<template>
  <div class="setup-view">
    <main class="pt-3">
      <div class="container-fluid">
        <b-row>
          <b-col cols="2"/>
          <b-col cols="8">
            <router-view></router-view>
            <hm-footer/>
          </b-col>
          <b-col cols="2"/>
        </b-row>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'SetupContainer',
  data() {
    return {
      inSetup: true
    }
  }
}
</script>

<style>
.setup-view {
  background-color: #fff;
}
</style>